<div [formGroup]="gs.gastroForm">
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary" style="display: flex; flex-direction: column">
    <div class="w100">
      <section class="m-box fulltext">
        <h2>Medical Background</h2>
        <button
          class="t-btn-smart"
          *ngIf="!es.isClosed && ls.premissions && ls.premissions['Questionnaires']"
          [disabled]="aiSummaryLoading"
          style="margin-bottom: 0.5em"
          (click)="getAiSummary()"
        >
          {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
          <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
        </button>
        <textarea formControlName="MedicalBackground" class="scroller scroller-intro fulltext"></textarea>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(gs.gastroForm?.get('MedicalBackground'), 'Medical Background', 8700)"
        >
          Auto Text
        </button>
      </section>

      <section class="m-box fulltext">
        <h2>Time Out</h2>
        <textarea formControlName="TimeOut" class="scroller scroller-intro fulltext"></textarea>

        <button
          class="t-btn-edit"
          style="right: 8em"
          (click)="showTimeOutForm = true; gfs.loadForm('fromExam', true, undefined, true)"
        >
          Time Out Form
        </button>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(gs.gastroForm?.get('TimeOut'), 'Time Out', 109)"
        >
          Auto Text
        </button>
      </section>
    </div>
  </div>
  <div class="w100">
    <app-gastro-summary></app-gastro-summary>
  </div>
</div>
<app-patforms *ngIf="showTimeOutForm" (closed)="close()"></app-patforms>